"use client";

/**
 * SlashMenuPlugin 与块手柄「+」共享：
 * 用户点击外部关掉斜杠菜单后置 true，阻止菜单立刻再弹；
 * 段落不再以 `/` 开头、或点击「+」主动插入 `/` 时置 false。
 */
export const slashMenuCancelledUntilNextSlashRef = { current: false };
